import { get } from 'services/api';
import { API_V4_BASE_URL } from 'settings';

const receiveModules = (modules: Object[]) => ({
  type: 'RECEIVE_MODULES',
  modules,
});

const receiveModulesError = (error: any) => ({
  type: 'RECEIVE_MODULES_ERROR',
  error,
});

export const cleanModules = () => (dispatch: any) =>
  dispatch({
    type: 'CLEAN_MODULES',
  });

export const fetchModules = (courseHash: string) => (dispatch: any, getState: Function) => {
  const state = getState();
  const modules = state.modules || [];
  if (modules.length) {
    return modules;
  }
  dispatch({
    type: 'REQUEST_MODULES',
  });

  get({
    url: `/learner/course/${courseHash}/modules/v2`,
    baseURL: API_V4_BASE_URL,
  })
    .then(
      (res) => {
        const modules = res.data.data || [];
        dispatch(receiveModules(modules));
      },
      (err) => dispatch(receiveModulesError(err))
    )
    .catch((err) => dispatch(receiveModulesError(err)));
};

export const onAcceptModules = () => (dispatch: any) => {
  dispatch({
    type: 'ON_ACCEPT_TERMS',
  });
};
